import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

interface ProtectedRouteProps {
  requiredPermission: string;
  children?: React.ReactNode;
  redirectTo?: string;
}

/**
 * ProtectedRoute shields React Router Navigation DOM trees intercepting state loads dynamically.
 * Asserts contextual RBAC array mapping strings implicitly emitting redirects against unauthorized hits.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  requiredPermission,
  children,
  redirectTo,
}) => {
  const { rolePermissions, isAuthenticated } = useAuth();

  const hasPermission = rolePermissions?.some(
    (permission) => permission === requiredPermission,
  );
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (redirectTo && !hasPermission) {
    return <Navigate to={redirectTo} />;
  }

  if (!hasPermission) {
    return <Navigate to="/forbidden" />;
  }

  return <div>{children}</div>;
};

export default ProtectedRoute;
